import { useState, useEffect } from 'react';
import api from '../services/api';

const DEFAULT_NIVELES = [
  { id:'standard', name:'Standard', color:'#888', min_points:0,    max_points:999,   benefits:'Acumulación de puntos básica', multiplier:1 },
  { id:'silver',   name:'Silver',   color:'#aaa', min_points:1000, max_points:4999,  benefits:'2x puntos en compras + acceso a preventas', multiplier:2 },
  { id:'gold',     name:'Gold',     color:'#b8860b', min_points:5000, max_points:null, benefits:'3x puntos + envío gratis + descuentos exclusivos', multiplier:3 },
];

export default function Niveles() {
  const [niveles, setNiveles] = useState(DEFAULT_NIVELES);
  const [editing, setEditing] = useState(null);
  const [saved, setSaved] = useState(false);

  const update = (id, field, value) => {
    setNiveles(prev => prev.map(n => n.id === id ? {...n, [field]: value} : n));
  };

  const save = async () => {
    try {
      await api.post('/api/loyalty/levels', { levels: niveles });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { /* handle silently */ }
  };

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Niveles de Lealtad</h1>
          <p style={s.sub}>Define las reglas de puntos y beneficios para cada nivel</p>
        </div>
        <button style={s.btnPrimary} onClick={save}>
          {saved ? 'Guardado' : 'Guardar cambios'}
        </button>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
        {niveles.map((nivel, i) => (
          <div key={nivel.id} style={s.card}>
            <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
              <div style={{ width:4, height:40, background:nivel.color }} />
              <div>
                <div style={{ fontSize:18, fontWeight:700, fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:1, color:'#111' }}>{nivel.name}</div>
                <div style={{ fontSize:12, color:'#aaa', letterSpacing:1 }}>Nivel {i+1} de {niveles.length}</div>
              </div>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px,1fr))', gap:16 }}>
              <div>
                <label style={s.label}>Puntos mínimos</label>
                <input style={s.input} type="number" min={0} value={nivel.min_points}
                  onChange={e => update(nivel.id, 'min_points', parseInt(e.target.value))} />
              </div>
              <div>
                <label style={s.label}>Puntos máximos</label>
                <input style={s.input} type="number" value={nivel.max_points || ''}
                  placeholder="Sin límite"
                  onChange={e => update(nivel.id, 'max_points', e.target.value ? parseInt(e.target.value) : null)} />
              </div>
              <div>
                <label style={s.label}>Multiplicador de puntos</label>
                <input style={s.input} type="number" min={1} max={10} step={0.5} value={nivel.multiplier}
                  onChange={e => update(nivel.id, 'multiplier', parseFloat(e.target.value))} />
              </div>
              <div>
                <label style={s.label}>Color del nivel</label>
                <div style={{ display:'flex', gap:8 }}>
                  <input type="color" value={nivel.color} onChange={e => update(nivel.id, 'color', e.target.value)}
                    style={{ width:44, height:40, border:'1.5px solid #e5e5e5', cursor:'pointer', padding:2 }} />
                  <input style={{...s.input, flex:1}} value={nivel.color} onChange={e => update(nivel.id, 'color', e.target.value)} />
                </div>
              </div>
              <div style={{ gridColumn:'1/-1' }}>
                <label style={s.label}>Beneficios</label>
                <input style={s.input} value={nivel.benefits}
                  onChange={e => update(nivel.id, 'benefits', e.target.value)}
                  placeholder="Describe los beneficios de este nivel" />
              </div>
            </div>

            <div style={s.previewBar}>
              <span style={{ fontSize:11, color:'#aaa', letterSpacing:1, textTransform:'uppercase' }}>Preview en el pass</span>
              <span style={{ background:nivel.color, color:'#fff', padding:'4px 12px', fontSize:12, fontWeight:700, letterSpacing:1 }}>
                {nivel.name} — {nivel.multiplier}x puntos
              </span>
            </div>
          </div>
        ))}
      </div>

      <div style={s.infoBox}>
        Los niveles se aplican automáticamente cuando el balance de puntos del cliente alcanza el mínimo requerido. El pass se actualiza en tiempo real.
      </div>
    </div>
  );
}

const s = {
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28 },
  title: { fontSize:24, fontWeight:700, margin:'0 0 4px', color:'#111', fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:-0.5 },
  sub: { fontSize:13, color:'#888', margin:0 },
  card: { background:'#fff', border:'1px solid #eee', padding:24 },
  label: { display:'block', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', color:'#555', marginBottom:6 },
  input: { width:'100%', padding:'10px 14px', border:'1.5px solid #e5e5e5', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:"'Barlow',sans-serif", borderRadius:0 },
  previewBar: { display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:20, paddingTop:16, borderTop:'1px solid #f5f5f5' },
  btnPrimary: { background:'#111', color:'#fff', border:'none', padding:'10px 20px', fontSize:12, fontWeight:600, letterSpacing:2, textTransform:'uppercase', cursor:'pointer', fontFamily:"'Barlow',sans-serif" },
  infoBox: { background:'#fafafa', border:'1px solid #eee', padding:16, fontSize:13, color:'#666', lineHeight:1.6, marginTop:24 },
};
